<template>
  <!-- 報告書一括出力 -->
  <div id="AppReportbatchPrintSearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">報告書一括印刷</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="期間" labelPosition="on-border">
              <b-field
                label
                labelPosition="on-border"
                :type="{'is-danger':errors.has('startDate')}"
              >
                <b-datepicker
                  v-model="startDate"
                  name="startDate"
                  placeholder="検索開始年月日"
                  icon="calendar-today"
                  :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                  :day-names="['日','月','火','水','木','金','土']"
                  v-validate="'dateRange:endDate'"
                  data-vv-validate-on="input"
                >
                  <button
                    class="button is-danger"
                    @click="startDate = null,searchConditions.startDate= ''"
                  >
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </button>
                </b-datepicker>
              </b-field>
              <b-field
                label
                labelPosition="on-border"
                :type="{'is-danger':errors.has('endDate')}"
              >
                <b-datepicker
                  v-model="endDate"
                  name="endDate"
                  placeholder="検索終了年月日"
                  icon="calendar-today"
                  :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                  :day-names="['日','月','火','水','木','金','土']"
                  v-validate="'dateRange:startDate'"
                  data-vv-validate-on="input"
                >
                  <button
                    class="button is-danger"
                    @click="endDate = null,searchConditions.endDate= ''"
                  >
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </button>
                </b-datepicker>
              </b-field>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="点検担当者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="点検担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.recipientCode"
                name="recipientCode"
                data-vv-as="患者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.recipientName"
                name="recipientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field
              label="予約番号"
              labelPosition="on-border"
              :type="{'is-danger':errors.has('appointmentCode')}"
              :message="errors.first('appointmentCode')"
            >
              <b-input
                v-model="searchConditions.appointmentCode"
                name="appointmentCode"
                data-vv-as="予約番号"
                type="text"
                v-validate="'numeric'"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--4行目 -->
        <div class="columns">
          <div class="column is-one-thirds">
            <b-field label="受け渡し種別" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button v-model="searchConditions.formGroup" native-value="1">手持ち</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.formGroup" native-value="2">送付</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.formGroup" native-value="3">N/A</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.formGroup" native-value="4">点検報告書送付不要</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.formGroup" native-value="5">PCP公開</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.formGroup" native-value="6">ナビエク郵送</b-checkbox-button>
            </b-field>
          </div>
          <div class="column is-one-thirds">
            <b-field label="印刷種別" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button v-model="searchConditions.printKindGroup" native-value="1">患者</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.printKindGroup" native-value="2">医療機関</b-checkbox-button>
            </b-field>
          </div>
          <div class="column is-one-thirds">
            <b-field label="ステータス" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button v-model="searchConditions.statusGroup" native-value="2">未出力</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.statusGroup" native-value="3">確認済</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.statusGroup" native-value="1">出力済</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.statusGroup" native-value="4">PCP公開済</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.statusGroup" native-value="5">ナビエク郵送済</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.statusGroup" native-value="6">PCP閲覧済</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!--5行目 -->
        <div class="columns">
          <div class="column is-two-thirds">
            <b-field label="点検種別" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="0"
              >院内/当社点検有</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="1"
              >院内/当社点検無し</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="2"
              >在宅/当社点検</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="3"
              >在宅/ディーラー点検</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="4"
              >院内・在宅/RR点検不要</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.inspectionKindGroup" native-value="5">社内器</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.inspectionKindGroup"
                native-value="6"
              >
                フリーメンテ
              </b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span v-if="errors.has('startDate')" style="color: red">{{errors.first('startDate')}}</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <section>
      <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column" style="text-align:left;">
            <b-button
              style="margin-bottom: 5px"
              :disabled="!checkedRows.length"
              class="button is-primary has-text-centered"
              icon-left="printer"
              native-type="button"
              v-on:click="goReportPreview"
              >報告書確認（プレビュー）</b-button
            >
            <b-button
              style="margin-bottom: 5px"
              :disabled="!checkedRows.length"
              class="button is-primary has-text-centered"
              icon-left="file-send"
              native-type="button"
              v-on:click="showSelectSendTypeModal()"
              >受け渡し種別一括変更</b-button
            >
            <b-modal :active.sync="isSelectSentTypeModalActive" has-modal-card>
              <select-send-type
                v-if="isSelectSentTypeModalActive"
                :title="'受け渡し種別一括変更'"
                :printType="selectedKind"
                @selected="updateSendTypes"
              />
            </b-modal>
          </div>
          <div class="column"  style="text-align:right;">
            <b-button
              class="button is-primary has-text-centered"
              icon-left="download"
              style="margin-bottom:5px;"
              native-type="button"
              v-on:click="downloadPlan"
            >ダウンロード</b-button>
            <b-button
              style="margin-bottom: 5px"
              class="button is-primary has-text-centered"
              icon-left="mdi mdi-text-box-multiple"
              native-type="button"
              v-on:click="goPrintHistory"
              >印刷履歴</b-button
            >
          </div>
        </div>

        <div class="columns">
          <div class="column is-4" style="text-align:left;">
            <b-button
              v-if="isShowNaviexp"
              style="margin-bottom: 5px"
              :disabled="!checkedRows.length"
              class="button is-primary has-text-centered"
              native-type="button"
              v-on:click="goPrintStartNaviexp"
              >ナビエク郵送</b-button
            >
            <b-button
              style="margin-bottom: 5px"
              :disabled="!checkedRows.length"
              class="button is-primary has-text-centered"
              native-type="button"
              v-on:click="goCancelPublishPCP"
              >PCP公開取消</b-button
            >
          </div>
          
          <div class="column" style="text-align:right;">
            <b-button
              style="margin-bottom: 5px"
              :disabled="!checkedRows.length"
              class="button is-primary has-text-centered"
              icon-left="printer"
              native-type="button"
              v-on:click="goPrintStart"
            >報告書印刷</b-button>
            <b-button
              style="margin-bottom: 5px"
              class="button is-primary has-text-centered"
              :disabled="!checkedRows.length"
              icon-left="printer"
              native-type="button"
              v-on:click="goPrintStartTeikei"
            >宛名印刷(定型封筒)</b-button>
            <b-button
              style="margin-bottom: 5px"
              class="button is-primary has-text-centered"
              :disabled="!checkedRows.length"
              icon-left="printer"
              native-type="button"
              v-on:click="goPrintStartA4"
            >宛名印刷(A4封筒)</b-button>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <b-field horizontal label="検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="appointmentCode"
            checkable
            :checked-rows.sync="checkedRows"
            checkbox-position="left"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column
                field="appointmentCode"
                label="予約番号"
                sortable
                centered
                style="width: 120px;"
              >{{ props.row.appointmentCode }}</b-table-column>
              <b-table-column
                field="crossBorderCofficeSrc"
                label="越境依頼元"
                sortable
                centered
                style="width: 150px;"
              >{{ props.row.crossBorderCofficeSrc }}</b-table-column>
              <b-table-column
                field="crossBorderCofficeTar"
                label="越境依頼先"
                sortable
                centered
                style="width: 150px;"
              >{{ props.row.crossBorderCofficeTar }}</b-table-column>
              <b-table-column
                field="recipientName"
                label="患者名"
                sortable
                centered
                style="width: 150px;"
              >{{ props.row.recipientName }}</b-table-column>
              <b-table-column
                field="hospitalName"
                label="医療機関名"
                sortable
                centered
                style="width: 150px;"
              >{{ props.row.hospitalName }}</b-table-column>
              <b-table-column
                field="productName"
                label="点検機器"
                sortable
                style="width: 120px;"
              >{{ props.row.productName }}</b-table-column>
              <b-table-column
                v-if="props.row.kind=='2'"
                field="sendType"
                label="受け渡し種別"
                sortable
                centered
                style="width: 70px;"
              >{{ props.row.sendType|sendTypeFillter }}</b-table-column>
              <b-table-column
                v-else-if="props.row.kind=='1'"
                field="sendType"
                label="受け渡し種別"
                sortable
                centered
                style="width: 160px;"
              >{{ props.row.sendType|sendTypePatientFillter }}</b-table-column>
              <b-table-column
                field="kind"
                label="印刷種別"
                sortable
                centered
                style="width: 70px;"
              >{{ props.row.kind | printingKindFillter}}</b-table-column>

              <b-table-column
                field="staffName"
                label="点検担当者"
                sortable
                centered
                style="width: 100px;"
              >{{ getRowItem(props.row.staffName,20) }}</b-table-column>

              <b-table-column
                field="completionDate"
                label="点検実施日"
                sortable
                centered
                style="width: 30px;"
              >{{ props.row.completionDate }}</b-table-column>
              <b-table-column
                field="status"
                label="ステータス"
                sortable
                centered
                :style="statusStyle(props.row, 'width: 70px')"
                >{{
                  props.row.status | printingStatusFillter()
                }}</b-table-column
              >
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
const dayjs = require('dayjs');

const constInspection = require("../utils/inspection");
const constUser = require("../utils/user");

import SelectSendType from "./common/SelectSendType.vue";

var data = [];
export default {
  name: "AppReportbatchPrintSearch",

  computed: {
    isShowNaviexp: function() {
      const isShowNaviexp = this.userInfo.roleId == constUser.ROLE_ID_MAP.systemManager ? true : false;
      return isShowNaviexp;
    },
  },

  methods: {
    getRowItem: function(value, length) {
      return value && value.length > length
        ? value.substr(0, length) + "..."
        : value;
    },
    search: async function(searchConditions) {
      const validateAll = await this.$validator.validateAll();
      if (!validateAll) {
        return;
      }
      this.checkedRows = [];
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.recipientCode) ||
        this.isLength(this.searchConditions.recipientName) ||
        this.isLength(this.searchConditions.appointmentCode) ||
        this.searchConditions.formGroup.length > 0 ||
        this.searchConditions.printKindGroup.length > 0 ||
        this.searchConditions.statusGroup.length > 0 ||
        this.searchConditions.inspectionKindGroup.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.startDate = this.formatDate(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.endDate = this.formatDate(this.endDate);
        }
        var excuteApi = this.getInspectionResultListPOST;
        var successCallBack = this.getInspectionResultListSuccess;
        var errorCallBack = this.getInspectionResultListError;
        //WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
      }
    },
    getInspectionResultListPOST: function(client) {
      for (var val in this.searchConditions.formGroup) {
        this.searchConditions.formGroup[val] = parseInt(
          this.searchConditions.formGroup[val]
        );
      }
      for (var val in this.searchConditions.statusGroup) {
        this.searchConditions.statusGroup[val] = parseInt(
          this.searchConditions.statusGroup[val]
        );
      }
      for (var val in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[val] = parseInt(
          this.searchConditions.inspectionKindGroup[val]
        );
      }
      for (var val in this.searchConditions.printKindGroup) {
        this.searchConditions.printKindGroup[val] = parseInt(
          this.searchConditions.printKindGroup[val]
        );
      }

      return client.apis.apiInspection.getInspectionResultListPOST({
        body: {
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          startDate: this.searchConditions.startDate,
          endDate: this.searchConditions.endDate,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          recipientCode: this.searchConditions.recipientCode,
          recipientName: this.searchConditions.recipientName,
          printType: this.searchConditions.printKindGroup,
          inspectionType: this.searchConditions.inspectionKindGroup,
          sendType: this.searchConditions.formGroup,
          status: this.searchConditions.statusGroup,
          officeCode: this.searchConditions.officeCode,
          appointmentCode: this.searchConditions.appointmentCode
        }
      });
    },
    getInspectionResultListSuccess: function(result) {
      // 検索条件保持
      this.searchedConditions = JSON.parse(JSON.stringify(this.searchConditions));

      // WebAPI応答内容を画面に設定
      this.data = [];
      this.data = result.obj;
      for (var val in this.searchConditions.formGroup) {
        this.searchConditions.formGroup[val] =
          this.searchConditions.formGroup[val] + "";
      }
      for (var val in this.searchConditions.statusGroup) {
        this.searchConditions.statusGroup[val] =
          this.searchConditions.statusGroup[val] + "";
      }
      for (
        var val = 0;
        val < this.searchConditions.inspectionKindGroup.length;
        val++
      ) {
        this.searchConditions.inspectionKindGroup[val] =
          this.searchConditions.inspectionKindGroup[val] + "";
      }
      for (var val in this.searchConditions.printKindGroup) {
        this.searchConditions.printKindGroup[val] =
          this.searchConditions.printKindGroup[val] + "";
      }
    },
    getInspectionResultListError: function(result) {
      this.showErrorMessage(result);
      for (var val in this.searchConditions.formGroup) {
        this.searchConditions.formGroup[val] =
          this.searchConditions.formGroup[val] + "";
      }
      for (var val in this.searchConditions.statusGroup) {
        this.searchConditions.statusGroup[val] =
          this.searchConditions.statusGroup[val] + "";
      }
      for (var val in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[val] =
          this.searchConditions.inspectionKindGroup[val] + "";
      }
      for (var val in this.searchConditions.printKindGroup) {
        this.searchConditions.printKindGroup[val] =
          this.searchConditions.printKindGroup[val] + "";
      }
    },

    checkConditions: async function(errorMessage, sendTypes, statuses, isSkipOffice = false, isSkipDayRange = false, isNotPublish = false) {
      let res = true;
      let officeCode = this.checkedRows && this.checkedRows.length > 0 ? this.checkedRows[0].crossBorderCofficeSrcCode : null;;
      const completionDate = this.checkedRows && this.checkedRows.length > 0 ? dayjs(this.checkedRows[0].completionDate) : null;
      let completionDateMin = completionDate;
      let completionDateMax = completionDate;
      let isChangedRange = false;
      let notExistsInspectionReportFile;
      let existsOutputedNaviexp;

      for (const checkedRow of this.checkedRows) {
        // 受け渡し種別判定
        if (!sendTypes.includes(checkedRow.sendType)) {
          await this.showErrorMessage(errorMessage);
          return false;
        }

        // ステータス判定
        if (!statuses.includes(checkedRow.status)) {
          await this.showErrorMessage(errorMessage);
          return false;
        }

        // 営業所判定
        if (!isSkipOffice) {
          if (officeCode != checkedRow.crossBorderCofficeSrcCode) {
            await this.showErrorMessage(errorMessage);
            return false;
          }
        }

        // 期間判定
        if (!isSkipDayRange) {
          const completionDate = dayjs(checkedRow.completionDate);
          const diffDateMin = completionDateMin.diff(completionDate, "day");
          if (diffDateMin > 0) {
            isChangedRange = true;
            completionDateMin = completionDate;
          }
          const diffDateMax = completionDateMax.diff(completionDate, "day");
          if (diffDateMax < 0) {
            isChangedRange = true;
            completionDateMax = completionDate;
          }
          if (isChangedRange) {
            const diffDate = completionDateMax.diff(completionDateMin, "day");
            console.log(diffDate);
            if (diffDate > 31) {
              await this.showErrorMessage(errorMessage);
              return false;
            }
            isChangedRange = false;
          }
        }

        // ファイル有無判定
        if (!checkedRow.existsInspectionReportFile) {
          notExistsInspectionReportFile = true;
        }

        // ナビエク郵送済有無判定
        if (checkedRow.status == constInspection.PRINT_STATUS_MAP.outputedNaviexp.code) {
          existsOutputedNaviexp = true;
        }
      }

      // 警告
      if (!isNotPublish && existsOutputedNaviexp) {
        res = await this.showComfirmMessage(
          "既にナビエクに連携された報告書が選択されています。\n\n再送する場合はこのまま出力してください。"
        );
        if (!res) {
          return res;
        }
      }
      
      if (!isNotPublish && notExistsInspectionReportFile) {
        res = await this.showComfirmMessage(
          "点検報告書の保存期間を超過している行を含んでいるため、処理に時間が掛かる場合があります。\n\n処理を継続しますか？"
        );
        if (!res) {
          return res;
        }
      }

      return res;
    },

    goPrintStart: async function (event) {
      // 報告書印刷条件判定
      let errorMessage = "報告書印刷を行う場合は、以下の条件を満たす行を選択してください。\n";
        errorMessage += "\n";
        errorMessage += "<li>営業所コード: 単一</li>";
        errorMessage += "<li>期間: 31日以下</li>";
        errorMessage += "<li>受け渡し種別: 手持ち、または送付のいずれか</li>";
        errorMessage += "<li>ステータス: 確認済、または印刷済</li>";
      const sendTypes = [
        constInspection.SEND_TYPE_HOSPITAL_MAP.hold.code,
        constInspection.SEND_TYPE_HOSPITAL_MAP.send.code,
      ];
      const statuses = [
        constInspection.PRINT_STATUS_MAP.confirmed.code,
        constInspection.PRINT_STATUS_MAP.outputed.code,
      ];
      let checkConditions = await this.checkConditions(errorMessage, sendTypes, statuses);
      if (!checkConditions) {
        return false;
      }

      // downloadInspectionReport
      // パラメータ：checkedRowseの配列
      var excuteApi = this.downloadInspectionReportPOST;
      var errorCallBack = this.downloadReportFileError;
      var successCallBack = this.downloadReportFileSuccess;
      //WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack, null, successCallBack);
    },
    downloadInspectionReportPOST: function(client) {
      var objList = [];
      for (var i = 0; this.$data.checkedRows.length > i; i++) {
        objList.push({
          appointmentCode: this.$data.checkedRows[i].appointmentCode,
          inspectionId: this.$data.checkedRows[i].inspectionCode,
          printType: this.$data.checkedRows[i].kind,
          sendType: this.$data.checkedRows[i].sendType,
          destinationId: this.$data.checkedRows[i].destinationId,
        });
      }
      return client.apis.apiInspection.downloadInspectionReportPOST({
        body: objList,
      });
    },
    downloadReportFileSuccess: function (result) {
      // 再検索を行わないため、選択行の状態を更新
      for (const row of this.checkedRows) {
        row.status = constInspection.PRINT_STATUS_MAP.outputed.code;
        row.existsInspectionReportFile = true;
      }
      return;
    },
    downloadReportFileError: function (result) {
      this.showErrorMessage(result);
    },

    checkHospitalPCP: async function () {
      const hospitals = [];

      for (const checkedRow of this.checkedRows) {
        // kitamura PCP紐づけチェック
        const hospital = {
          code: checkedRow.hospitalCode,
          name: checkedRow.hospitalName,
        };
        hospitals.push(hospital);
      }

      if (hospitals.length) {
        let message = "PCPの呼吸点検報告書サービスを利用していない以下の医療機関には公開できません。\n";
        message += "該当する医療機関を除いて、処理を継続しますか？";
        for (const hospital of hospitals) {
          message += "<li>" + hospital.code + ": " + hospital.name + "</li>"
        }
        const comfirmExec = await this.showComfirmMessage(message);
        if (!comfirmExec) {
          return false;
        }
      }

      return true;
    },

    goCancelPublishPCP: async function (event) {
      // PCP公開取消条件判定
      let errorMessage = "PCP公開取消を行う場合は、以下の条件を満たす行を選択してください。\n";
        errorMessage += "\n";
        errorMessage += "<li>受け渡し種別: PCP公開</li>";
        errorMessage += "<li>ステータス: PCP公開済</li>";
      const sendTypes = [
        constInspection.SEND_TYPE_HOSPITAL_MAP.pcp.code,
      ];
      const statuses = [
        constInspection.PRINT_STATUS_MAP.outputedPcp.code,
      ];
      let checkConditions = await this.checkConditions(errorMessage, sendTypes, statuses, true, true, true);
      if (!checkConditions) {
        return false;
      }

      // 実行確認
      const comfirmExec = await this.showComfirmMessage(
        "この操作を行うと点検報告書の外部ユーザーへの公開が取り消されます。\n\n処理を継続しますか？"
      );
      if (!comfirmExec) {
        return false;
      }

      //WebAPI Call
      this.chengeStatus = constInspection.PRINT_STATUS_MAP.confirmed.code;
      this.apiCall(
        this.putInspectionReportsPUT,
        this.putInspectionReportsPUTsucces,
        this.putInspectionReportsPUTerror
      );
      return;
    },

    putInspectionReportsPUT: function (client) {
      const inspectionReports = [];
      for (var i = 0; this.$data.checkedRows.length > i; i++) {
        inspectionReports.push({
          reservationId: Number(this.$data.checkedRows[i].appointmentCode),
          inspectionId: Number(this.$data.checkedRows[i].inspectionCode),
          printType: this.$data.checkedRows[i].kind,
          sendType: this.$data.checkedRows[i].sendType,
          destinationId: this.$data.checkedRows[i].destinationId,
          status: this.chengeStatus,
        });
      }
      const apiRes = client.apis.apiInspection.putInspectionReportsPUT({
        body: {
          inspectionReports: inspectionReports,
        },
      });
      return apiRes;
    },
    putInspectionReportsPUTsucces: async function (result) {
      this.showSuccess(result);

      // 検索
      this.search();
      return;
    },
    putInspectionReportsPUTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },

    goPrintStartNaviexp: async function (event) {
      // ナビエク郵送条件判定
      let errorMessage = "ナビエク郵送を行う場合は、以下の条件を満たす行を選択してください。\n";
      errorMessage += "\n";
      errorMessage += "<li>営業所コード: 単一</li>";
      errorMessage += "<li>期間: 31日以下</li>";
      errorMessage += "<li>受け渡し種別: ナビエク郵送</li>";
      errorMessage += "<li>ステータス: 確認済、またはナビエク郵送済</li>";
      const sendTypes = [
        constInspection.SEND_TYPE_HOSPITAL_MAP.naviexp.code,
      ];
      const statuses = [
        constInspection.PRINT_STATUS_MAP.confirmed.code,
        constInspection.PRINT_STATUS_MAP.outputedNaviexp.code,
      ];
      let checkConditions = await this.checkConditions(errorMessage, sendTypes, statuses);
      if (!checkConditions) {
        return false;
      }

      // パラメータ：checkedRowseの配列
      var excuteApi = this.downloadInspectionReportNaviexpPOST;
      var successCallBack = this.downloadReportFileNaviexpSuccess;
      var errorCallBack = this.downloadReportFileNaviexpError;
      //WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    downloadInspectionReportNaviexpPOST: function (client) {
      var objList = [];
      for (var i = 0; this.$data.checkedRows.length > i; i++) {
        objList.push({
          appointmentCode: this.$data.checkedRows[i].appointmentCode,
          inspectionId: this.$data.checkedRows[i].inspectionCode,
          printType: this.$data.checkedRows[i].kind,
          sendType: this.$data.checkedRows[i].sendType,
          destinationId: this.$data.checkedRows[i].destinationId,
          salesOfficeCode: this.$data.checkedRows[i].crossBorderCofficeSrc,
        });
      }
      return client.apis.apiInspection.downloadInspectionReportNaviexpPOST({
        body: objList,
      });
    },
    downloadReportFileNaviexpSuccess: function (result) {
      // ダウンロード
      let name = result.headers['content-disposition'].split('=')[1];
      name = name.slice(name.lastIndexOf('\'') + 1);


      const blob = result.data;
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(name);
      link.click();

      // 検索
      this.search();
      return;
    },
    downloadReportFileNaviexpError: function (result) {
      this.showErrorMessage(result);
      return;
    },

    goPrintStartTeikei: function(event) {
      // getDestinationsForStandardSizeMail
      // パラメータ：checkedRowseの配列
      var excuteApi = this.getDestinationsForStandardSizeMailPOST;
      var errorCallBack = this.downloadStandardSizeMailError;
      //WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack);
    },
    getDestinationsForStandardSizeMailPOST: function(client) {
      var objList = [];
      for (var i = 0; this.$data.checkedRows.length > i; i++) {
        objList.push({
          inspectionId: this.$data.checkedRows[i].inspectionCode,
          printType: this.$data.checkedRows[i].kind
        });
      }
      return client.apis.apiInspection.getDestinationsForStandardSizeMailPOST({
        body: objList
      });
    },
    downloadStandardSizeMailError: function(result) {
      this.showErrorMessage(result);
    },

    goPrintStartA4: function(event) {
      // getDestinationsForA4SizeMail
      // パラメータ：checkedRowsの配列
      var excuteApi = this.getDestinationsForA4SizeMailPOST;
      var errorCallBack = this.downloadA4SizeMailError;
      //WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack);
    },
    getDestinationsForA4SizeMailPOST: function(client) {
      var objList = [];
      for (var i = 0; this.$data.checkedRows.length > i; i++) {
        objList.push({
          inspectionId: this.$data.checkedRows[i].inspectionCode,
          printType: this.$data.checkedRows[i].kind
        });
      }
      return client.apis.apiInspection.getDestinationsForA4SizeMailPOST({
        body: objList
      });
    },
    downloadA4SizeMailError: function(result) {
      this.showErrorMessage(result);
    },
    goPrintHistory: function(event) {
      this.$router.push({
        name: "AppReportPrintHistory",
        params: {
          item: this.$data.checkedRows,
          searchConditions: this.searchConditions
        }
      });
    },
    goReportPreview: function (event) {
      this.$router.push({
        name: "AppReportPreview",
        params: {
          items: this.$data.checkedRows,
          searchConditions: this.searchConditions,
        },
      });
    },
    downloadPlan: function (event) {
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.recipientCode) ||
        this.isLength(this.searchConditions.recipientName) ||
        this.isLength(this.searchConditions.appointmentCode) ||
        this.searchConditions.formGroup.length > 0 ||
        this.searchConditions.printKindGroup.length > 0 ||
        this.searchConditions.statusGroup.length > 0 ||
        this.searchConditions.inspectionKindGroup.length > 0
      ) {
        console.log("ダウンロード条件あり");
        this.isSearchConditionNull = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.startDate = this.formatDate(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.endDate = this.formatDate(this.endDate);
        }
        var excuteApi = this.downloadInspectionReportTextFilePOST;
        var errorCallBack = this.downloadTextFileError;
        // WebAPI Call
        this.downloadApiCall(excuteApi, errorCallBack);
      } else {
        console.log("ダウンロード条件未入力");
        this.showErrorMessage("ダウンロード条件を指定してください。");
      }
    },
    downloadInspectionReportTextFilePOST: function(client) {
      var formGroup = [];
      for (var val in this.searchConditions.formGroup) {
        formGroup.push(parseInt(this.searchConditions.formGroup[val]));
      }
      var statusGroup = [];
      for (var val in this.searchConditions.statusGroup) {
        statusGroup.push(parseInt(this.searchConditions.statusGroup[val]));
      }
      var inspectionKindGroup = [];
      for (var val in this.searchConditions.inspectionKindGroup) {
        inspectionKindGroup.push(
          parseInt(this.searchConditions.inspectionKindGroup[val])
        );
      }
      var printKindGroup = [];
      for (var val in this.searchConditions.printKindGroup) {
        printKindGroup.push(
          parseInt(this.searchConditions.printKindGroup[val])
        );
      }
      return client.apis.apiInspection.downloadInspectionReportTextFilePOST({
        body: {
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          startDate: this.searchConditions.startDate,
          endDate: this.searchConditions.endDate,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          recipientCode: this.searchConditions.recipientCode,
          recipientName: this.searchConditions.recipientName,
          kind: printKindGroup,
          inspectionType: inspectionKindGroup,
          sendType: formGroup,
          status: statusGroup,
          officeCode: this.searchConditions.officeCode,
          appointmentCode: this.searchConditions.appointmentCode
        }
      });
    },
    downloadTextFileError: function(result) {
      this.showErrorMessage(result);
    },
    statusStyle: function(row, style) {
      let statusStyle = "";
      if (row.status == constInspection.PRINT_STATUS_MAP.viewed.code) {
        statusStyle += "color: red;"
      }
      statusStyle += style;
      return statusStyle;
    },

    showSelectSendTypeModal: async function() {
      // 印刷種別混在チェック
      const selectedKind = this.$data.checkedRows[0].kind;
      for (const checkedRow of this.$data.checkedRows) {
        if (selectedKind != checkedRow.kind) {
          const errorMessage = "印刷種別が混在しているため、受け渡し種別の一括変更は行えません。\n" 
            + "印刷種別が同一の点検報告書を選択してください。";
          await this.showErrorMessage(errorMessage);
          return;
        }
      }

      // ダイアログ表示
      this.selectedKind = selectedKind;
      this.isSelectSentTypeModalActive = true;
      return;
    },

    updateSendTypes: async function(sendType) {
      this.sendType = sendType;
      let isConfierm = false;

      // 印刷ステータスチェック 兼 有効情報収集
      for (const checkedRow of this.$data.checkedRows) {
        switch (checkedRow.status) {
          case constInspection.PRINT_STATUS_MAP.notOutput.code:
          case constInspection.PRINT_STATUS_MAP.confirmed.code:
            this.inspectionHistoryIds.push(Number(checkedRow.inspectionCode));
            break;

          default:
            isConfierm = true;
            break;
        }
        
      }

      // 処理継続確認
      if (isConfierm) {
        const confiermRes = await this.showComfirmMessage(
          "ステータスが未出力、確認済以外の場合は、受け渡し種別は変更できません。\n" +
          "該当する点検報告書を除いて、処理を継続しますか？"
        );
        if (!confiermRes) {
          // 処理中断
          return;
        }
      }

      // リクエスト
      this.apiCall(this.setSendTypes, this.setSendTypesSuccess, this.showErrorMessage);

      return;
    },
  
    setSendTypes: function (client) {
      // 受け渡し種別一括更新
      const res = client.apis.apiInspection.setSendTypesPOST({
        body: {
          printType: this.$data.checkedRows[0].kind,
          sendType: this.sendType,
          inspectionHistoryIds: this.inspectionHistoryIds,
        },
      });

      this.sendType = null;
      this.inspectionHistoryIds = [];

      return res;
    },

    setSendTypesSuccess: function (result) {
      if (result.obj) {
        this.showSuccess(result);
      }
      this.search(this.searchConditions);
      return;
    },
  },

  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var searchConditions = {
      startDate: "",
      endDate: "",
      staffCode: "",
      staffName: "",
      officeCode: "",
      hospitalCode: "",
      hospitalName: "",
      recipientCode: "",
      recipientName: "",
      appointmentCode: "",
      formGroup: [
        "" + (constInspection.SEND_TYPE_HOSPITAL_MAP.pcp.code + 1),
        "" + (constInspection.SEND_TYPE_HOSPITAL_MAP.naviexp.code + 1),
      ],
      printKindGroup: [
        "" + constInspection.PRINT_TYPE_MAP.hospital.code,
      ],
      statusGroup: [
        "" + constInspection.PRINT_STATUS_MAP.notOutput.code,
        "" + constInspection.PRINT_STATUS_MAP.confirmed.code,
      ],
      inspectionKindGroup: [
        "" + constInspection.INSPECTION_TYPE_MAP.hospitalMyCompany.code,
        "" + constInspection.INSPECTION_TYPE_MAP.homeMyCompany.code,
        "" + constInspection.INSPECTION_TYPE_MAP.homeDealer.code,
      ]
    };
    var startDate = null;
    var endDate = null;
    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];
      if (
        typeof searchConditions.startDate == "string" &&
        searchConditions.startDate != ""
      ) {
        startDate = this.parseDate(searchConditions.startDate);
      }
      if (
        typeof searchConditions.endDate == "string" &&
        searchConditions.endDate != ""
      ) {
        endDate = this.parseDate(searchConditions.endDate);
      }
    } else {
      if (userInfo.roleId != 1) {
        searchConditions.officeCode = userInfo.officeCode;
        searchConditions.staffCode = userInfo.staffCode;
        searchConditions.staffName = userInfo.fullName;
      }
    }
    return {
      data,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      checkedRows: [],
      flg: false,
      searchConditions,
      isSearchConditionNull: false,
      userInfo,
      startDate,
      endDate,
      changeStatus: null,
      selectedKind: null,
      isSelectSentTypeModalActive: false,
      sendType: null,
      inspectionHistoryIds: [],
    };
  },

  created: function() {
    this.$validator.extend("dateRange", {
      getMessage: field => `期間を指定してください。`,
      validate: (value, args) => {
        const valid = this.startDate || this.endDate ? true : false;
        if (valid) {
          this.errors.clear();
        } else {
          this.errors.add(
            {
              field: args[0],
              msg: "期間を指定してください。",
            }
          );
        }
        const ret = {
          valid: valid,
          data: {
            required: true,
          },
        };
        return ret;
      }
    },
    {
      computesRequired: true,
    });
    return;
  },

  mounted: function() {
    // WebApi Call
    this.search();
  },
  filters: {},
  components: {
    "select-send-type": SelectSendType,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppReportbatchPrintSearch.vue